import { faPhone } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a phone icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/phone?f=classic&s=solid
 */
export function PhoneIcon(props: CustomIconProps) {
  return <Icon icon={faPhone} {...props} />;
}
